"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAVSignatureInfo = void 0;
var conversions_1 = require("../../../../utils/conversions");
var DeviceCharacteristic_1 = require("../../../../common/DeviceCharacteristic");
var dataViewParsers_1 = require("../parsers/dataViewParsers");
var setAVSignatureInfo = function (device, message, signature, withResponse) {
    var signatureCode = (0, conversions_1.hexStringToArrayBuffer)(message + signature);
    return device
        .writeCharacteristicValues(device.profile.AGE_VERIFICATION.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.AVCharacteristics.SIGNATURE_VERIFICATION; }).uuid, signatureCode, withResponse)
        .then(function (res) { return (0, dataViewParsers_1.parseAVSignatureInfo)(res); });
};
exports.setAVSignatureInfo = setAVSignatureInfo;
